import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Check } from 'lucide-react';

type Lang = 'es' | 'en';

const LANGS: { code: Lang; flag: string; short: string }[] = [
  { code: 'es', flag: '🇪🇸', short: 'ES' },
  { code: 'en', flag: '🇬🇧', short: 'EN' },
];

const STORAGE_KEY = 'expai_language';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current = (i18n.language?.startsWith('en') ? 'en' : 'es') as Lang;
  const active = LANGS.find((l) => l.code === current) ?? LANGS[0];

  const change = (lang: Lang) => {
    void i18n.changeLanguage(lang);
    try {
      localStorage.setItem(STORAGE_KEY, lang);
      localStorage.setItem('app-language', lang);
    } catch {
      /* noop */
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 px-2 gap-1 text-xs font-medium"
          aria-label={t('header.language', 'Idioma')}
          title={t('header.language', 'Idioma')}
        >
          <span aria-hidden="true">{active.flag}</span>
          <span>{active.short}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => change(l.code)}
            className="flex items-center justify-between gap-2"
          >
            <span className="flex items-center gap-2">
              <span aria-hidden="true">{l.flag}</span>
              <span>{t(`language.${l.code}`)}</span>
            </span>
            {current === l.code && <Check className="h-3.5 w-3.5 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LanguageSwitcher;
